<form [formGroup]="strategyDefineForm" class="define-form strategy-form-section display-flex-column padding-bottom"
    autocomplete="off">
    <div class="responsive-flex">
        <div class="pad-8-hr spacer">
            <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline" color="accent">
                <label class="ut-label">Buy/Sell</label>

                <mat-select formControlName="orderMode">
                    <mat-option [value]="mode.value" *ngFor="let mode of ORDER_MODE | keyvalue">
                        {{ mode.value }}
                    </mat-option>
                </mat-select>

                <mat-error *ngIf="strategyDefineForm.get('orderMode').hasError('required')">
                    Buy/Sell is required
                </mat-error>
            </mat-form-field>
        </div>

        <div class="pad-8-hr spacer">
            <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline" color="accent">
                <label class="ut-label">Candle Size</label>

                <mat-select formControlName="candleSize">
                    <mat-option [value]="option.value" *ngFor="let option of CANDLE_OPTIONS | unsortedKeyValue">
                        {{ option.value }}
                    </mat-option>
                </mat-select>

                <mat-error *ngIf="strategyDefineForm.get('candleSize').hasError('required')">
                    Candle size is required
                </mat-error>
            </mat-form-field>
        </div>

        <div class="pad-8-hr spacer">
            <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline" color="accent">
                <label class="ut-label">Trade By</label>

                <mat-select formControlName="isLot" (selectionChange)="onTradeTypeChange()">
                    <mat-option [value]="true">
                        <span *ngIf="isCM; else elseBlock">
                            Qty
                        </span>
                        <ng-template #elseBlock><span>
                                Lots
                            </span></ng-template>
                    </mat-option>
                    <mat-option [value]="false">
                        Value
                    </mat-option>
                </mat-select>

                <mat-error *ngIf="strategyDefineForm.get('candleSize').hasError('required')">
                    Candle size is required
                </mat-error>
            </mat-form-field>
        </div>

        <div class="pad-8-hr spacer">
            <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline" color="accent">
                <label class="ut-label">Order {{ isLot ? isCM ? 'Qty' : 'Lots' : 'Value'}}</label>

                <div class="ng-spin-box-wrapper">
                    <input matInput ngSpinBox formControlName="orderQty" [min]="minValue" [step]="isLot ? 1: 0.05"
                        [max]="isLot ? MAX_LOT: MAX_VALUE" [decimal]="isLot ? 0 : 2">
                </div>

                <mat-error *ngIf="strategyDefineForm.get('orderQty').hasError('required')">
                    Order {{ isLot ? 'Lots' : 'Value'}} is required
                </mat-error>
                <mat-error *ngIf="strategyDefineForm.get('orderQty').hasError('min')">
                    Order {{ qtyLabel }} cannot be less than {{strategyDefineForm.get('orderQty').errors?.min.min}}
                </mat-error>
                <mat-error *ngIf="strategyDefineForm.get('orderQty').hasError('max')">
                    Order {{ qtyLabel }} cannot be more than {{strategyDefineForm.get('orderQty').errors?.max.max}}
                </mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="responsive-flex pad-8-hr" *ngIf="(strategyMode$ | async) !== StrategyFormBuildMode.REGULAR">
        <p class="text-accent cursor-pointer decoration-underline" (click)="showPreferences = !showPreferences">
            {{ showPreferences ? 'Hide': 'Show'}} Preference
        </p>
    </div>

    <ng-container *ngIf="showPreferences && (strategyMode$ | async) !== StrategyFormBuildMode.REGULAR">
        <div class="responsive-flex">
            <div class="pad-8 spacer">
                <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline"
                    color="accent">
                    <label class="ut-label">Product Type</label>

                    <mat-select formControlName="productType">
                        <mat-option [value]="product.value" *ngFor="let product of PRODUCT_TYPE | keyvalue">
                            {{ product.value }}
                        </mat-option>
                    </mat-select>

                    <mat-error *ngIf="strategyDefineForm.get('productType').hasError('required')">
                        Product is required
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="pad-8 spacer">
                <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline"
                    color="accent">
                    <label class="ut-label">Chart Type</label>

                    <mat-select formControlName="chartType">
                        <mat-option [value]="chart.value" *ngFor="let chart of CHART_TYPE | keyvalue">
                            {{ chart.value }}
                        </mat-option>
                    </mat-select>

                    <mat-error *ngIf="strategyDefineForm.get('chartType').hasError('required')">
                        Chart type is required
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="pad-8 spacer">
                <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline"
                    color="accent">
                    <label class="ut-label">Entry Order Price Method</label>

                    <mat-select formControlName="entryPriceMethod">
                        <mat-option [value]="method.value" *ngFor="let method of PRICE_METHOD | keyvalue">
                            {{ method.value }}
                        </mat-option>
                    </mat-select>

                    <mat-error *ngIf="strategyDefineForm.get('entryPriceMethod').hasError('required')">
                        Entry order price method is required
                    </mat-error>
                </mat-form-field>
            </div>


            <div class="pad-8 spacer">
                <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline"
                    color="accent">
                    <label class="ut-label">Exit Order Price Method</label>

                    <mat-select formControlName="exitPriceMethod">
                        <mat-option [value]="method.value" *ngFor="let method of PRICE_METHOD | keyvalue">
                            {{ method.value }}
                        </mat-option>
                    </mat-select>

                    <mat-error *ngIf="strategyDefineForm.get('exitPriceMethod').hasError('required')">
                        Exit order price method is required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="responsive-flex">
            <div class="pad-8 spacer">
                <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline" color="accent"
                    [class.half-width]="!(isWizardMode | async)">
                    <label class="ut-label">Algo Cycles</label>

                    <div class="ng-spin-box-wrapper">
                        <input matInput ngSpinBox formControlName="algoCycles" min="1" [step]="1" appNumberOnly>
                    </div>

                    <mat-error *ngIf="strategyDefineForm.get('algoCycles').hasError('required')">
                        Algo Cycles are required
                    </mat-error>
                    <mat-error *ngIf="strategyDefineForm.get('algoCycles').hasError('min')">
                        Algo Cycles should be greater than 1
                    </mat-error>
                    <mat-error *ngIf="strategyDefineForm.get('algoCycles').hasError('max')">
                        Algo Cycles should not be greater than 999
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="pad-8 spacer" *ngIf="isWizardMode | async">
                <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline"
                    color="accent">
                    <label class="ut-label">Rerun Algo</label>
                    <mat-select formControlName="rerunAlgo">
                        <mat-option [value]="interval.value" *ngFor="let interval of REACTIVATE_OPTIONS | keyvalue">
                            {{ interval.value }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="strategyDefineForm.get('algoCycles').hasError('required')">
                        Re-Run is required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <ng-container *ngIf="isWizardMode | async">
            <div class="responsive-flex margin-8-bottom">
                <div class="pad-8 spacer date-time-inputs">
                    <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline"
                        color="accent">
                        <label class="ut-label">Global Start Date</label>

                        <input matInput [owlDateTime]="startDatePicker" [owlDateTimeTrigger]="startDatePicker"
                            formControlName="startDate" [errorStateMatcher]="matcher">
                        <mat-icon matSuffix class="cursor-pointer" [owlDateTimeTrigger]="startDatePicker">today
                        </mat-icon>
                        <owl-date-time #startDatePicker pickerType="calendar"></owl-date-time>

                        <mat-error *ngIf="strategyDefineForm.get('startDate').hasError('required')">
                            Start date is required
                        </mat-error>
                        <mat-error *ngIf="strategyDefineForm.hasError('StartDateError')">
                            Current Date greater than Start Date
                        </mat-error>

                    </mat-form-field>
                </div>


                <div class="pad-8 spacer date-time-inputs">
                    <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline"
                        color="accent">
                        <label class="ut-label">Global End Date</label>

                        <input matInput [owlDateTime]="endDatePicker" [owlDateTimeTrigger]="endDatePicker"
                            formControlName="closeDate" [errorStateMatcher]="matcher">
                        <mat-icon matSuffix class="cursor-pointer" [owlDateTimeTrigger]="endDatePicker">today</mat-icon>
                        <owl-date-time #endDatePicker pickerType="calendar"></owl-date-time>

                        <mat-error *ngIf="strategyDefineForm.get('closeDate').hasError('required')">
                            End date is required
                        </mat-error>
                        <mat-error *ngIf="strategyDefineForm.hasError('DateError')">
                            Start Date greater than End Date
                        </mat-error>
                        <mat-error *ngIf="strategyDefineForm.hasError('EndDateError')">
                            Current Date greater than End Date
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="pad-8 spacer date-time-inputs">
                    <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline"
                        color="accent">
                        <label class="ut-label">Daily Start Time</label>

                        <input matInput [owlDateTime]="startTimePicker" [owlDateTimeTrigger]="startTimePicker"
                            formControlName="startTime" [errorStateMatcher]="matcher">
                        <mat-icon matSuffix class="cursor-pointer">schedule</mat-icon>
                        <owl-date-time #startTimePicker pickerType="timer"></owl-date-time>

                        <mat-error *ngIf="strategyDefineForm.get('startTime').hasError('required')">
                            Start time is required
                        </mat-error>
                        <mat-error *ngIf="strategyDefineForm.hasError('RangeMinError')">
                            Start time should be >= {{minTime}} (exchange time)
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="pad-8 spacer date-time-inputs">
                    <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline"
                        color="accent">
                        <label class="ut-label">Daily Square off Time</label>

                        <input matInput [owlDateTime]="endTimePicker" [owlDateTimeTrigger]="endTimePicker"
                            formControlName="closeTime" [errorStateMatcher]="matcher">
                        <mat-icon matSuffix class="cursor-pointer" [owlDateTimeTrigger]="endTimePicker">schedule
                        </mat-icon>
                        <owl-date-time #endTimePicker pickerType="timer"></owl-date-time>

                        <mat-error *ngIf="strategyDefineForm.get('closeTime').hasError('required')">
                            Square off time is required
                        </mat-error>

                        <mat-error *ngIf="strategyDefineForm.hasError('TimeError')">
                            Start Time greater than Square off Time
                        </mat-error>
                        <mat-error *ngIf="strategyDefineForm.hasError('CurrentTimeError')">
                            Current Time greater than Square off Time
                        </mat-error>
                        <mat-error *ngIf="strategyDefineForm.hasError('RangeMaxError')">
                            Square off time should be <= {{maxTime}} (exchange time) </mat-error>
                    </mat-form-field>
                </div>
            </div>


            <div class="responsive-flex margin-8-bottom">
                <div class="pad-8 spacer strategy-schedule flex-centered-container display-flex-column flex-start">
                    <div class="run-strategy-everyday full-width ut-pro-mat-form-field margin-top"
                        *ngIf="runStrategyEveryDay">
                        <mat-checkbox [formControl]="runStrategyEveryDay" [value]="true" color="accent">
                            Run Strategy Everyday
                        </mat-checkbox>
                    </div>

                    <div class="strategy-days flex-centered-container-vr" *ngIf="!runStrategyEveryDay.value">
                        <mat-checkbox class="pad-8" [value]="day" color="accent"
                            *ngFor="let day of dayNames;let i = index" [checked]="allowedDays.includes(i+1)"
                            (change)="runningDayChanged($event)">
                            {{ day }}
                        </mat-checkbox>
                    </div>
                </div>
            </div>

            <div class="responsive-flex margin-8-top position-time">
                <div class="pad-8 spacer flex-centered-container">
                    <mat-checkbox formControlName="enablePositionProtection" (change)="changesPositionSecurity($event)"
                        color="accent">Off-hours
                        Position Security
                    </mat-checkbox>
                </div>

                <div class="pad-8 spacer">
                    <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline"
                        color="accent">
                        <label class="ut-label">Position Exit Time</label>

                        <input matInput [owlDateTime]="positionExitTime" [owlDateTimeTrigger]="positionExitTime"
                            formControlName="positionExitTime">
                        <mat-icon matSuffix class="cursor-pointer" [owlDateTimeTrigger]="positionExitTime">schedule
                        </mat-icon>
                        <owl-date-time #positionExitTime pickerType="timer"></owl-date-time>

                        <mat-error *ngIf="strategyDefineForm.get('positionExitTime').hasError('required')">
                            Position Exit Time is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="pad-8 spacer">
                    <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline"
                        color="accent">
                        <label class="ut-label">Position Retake Time</label>

                        <input matInput [owlDateTime]="positionRetakeTime" [owlDateTimeTrigger]="positionRetakeTime"
                            formControlName="positionRetakeTime">
                        <mat-icon matSuffix class="cursor-pointer" [owlDateTimeTrigger]="positionRetakeTime">schedule
                        </mat-icon>
                        <owl-date-time #positionRetakeTime pickerType="timer"></owl-date-time>

                        <mat-error *ngIf="strategyDefineForm.get('positionRetakeTime').hasError('required')">
                            Position Retake Time is required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

    </ng-container>

</form>
